import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import AboutGene from './pages/AboutGene';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResearchPage from './pages/ResearchPage';
import ResourcePage from './pages/ResourcePage';
import AccountPage from './pages/AccountPage';
import FAQPage from './pages/FAQPage';
import DocumentUploadPage from './pages/DocumentUploadPage';
import PhotoGallery from './pages/PhotoGallery';
import AlbumCreator from './pages/AlbumCreator';
import TutorialPage from './pages/TutorialPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PricingPage from './pages/PricingPage';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicHomePage = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/research" /> : <LandingPage />;
};

function AppContent() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <div className="content">
          <Routes>
            <Route path="/" element={<PublicHomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/about-gene" element={<AboutGene />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/resources" element={<ResourcePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/tutorial" element={<TutorialPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/research" element={
              <PrivateRoute>
                <ResearchPage />
              </PrivateRoute>
            } />
            <Route path="/documents" element={
              <PrivateRoute>
                <DocumentUploadPage />
              </PrivateRoute>
            } />
            <Route path="/gallery" element={
              <PrivateRoute>
                <PhotoGallery />
              </PrivateRoute>
            } />
            <Route path="/album-creator" element={
              <PrivateRoute>
                <AlbumCreator />
              </PrivateRoute>
            } />
            <Route path="/account" element={
              <PrivateRoute>
                <AccountPage />
              </PrivateRoute>
            } />
            {/* Legacy route - redirect old landing page to home */}
            <Route path="/landing" element={<Navigate to="/" />} />
            {/* Dashboard route for authenticated users */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            } />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
// Build version: 1748651086
